import { fork, put, takeLatest, select, } from 'redux-saga/effects';
import { getType } from '../../utils';
import actions from './actions';
import { userFeedDataSelector } from './selectors';
export function* loadUserFeed(api, action) {
    try {
        const { userId, clientId, next: nextRequest, apiVersion } = action.payload;
        const { data: fullResponse } = yield api
            .getFeedByUserId({
            userId,
            clientId,
            next: nextRequest,
            apiVersion,
        })
            .then((p) => p.request);
        const userFeedData = yield select(userFeedDataSelector);
        const prevData = userFeedData || [];
        const nextData = fullResponse.data || [];
        yield put(actions.loadUserFeedSuccess({
            ...fullResponse,
            data: [...prevData, ...nextData],
        }));
    }
    catch (error) {
        yield put(actions.loadUserFeedError(true));
    }
}
export function* watchUserFeed(api) {
    yield takeLatest(getType(actions.loadUserFeed), loadUserFeed, api);
}
export const feedSagas = (api) => [fork(watchUserFeed, api)];
export default feedSagas;
